import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { KillmailEntity } from ".";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedKillmailEntity(
  killmail_id: number,
  killmail_hash: string
): Promise<KillmailEntity | null> {
  let entity: any = await cache.get(killmail_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const killmail = await esiClient.get_killmails_killmail_id_killmail_hash(null, null, killmail_hash, killmail_id);
    if (killmail !== null) {
      entity = new KillmailEntity(killmail_id, killmail);
      cache.put(killmail_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
